import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    commitmentBox: {
        border: '1px solid #0351A4',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        marginTop: '20px'
    },
    title: {
        backgroundColor: '#023f80',
        color: theme.palette.secondary.contrastText,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontWeight: 600,
    },
    listItem: {
        color: '#d32f2f', // Màu đỏ
        counterIncrement: 'list-item',
        '&::before': {
            content: 'counter(list-item) ". "',
            color: '#d32f2f',
            // fontWeight: 'bold',
            marginRight: theme.spacing(0.5),
        },
        padding: '0 16px',
        fontSize: '18px',
        '& .MuiListItemText-primary': {
            // fontWeight: 'bold',
            fontSize: '18px',
        }
    },
    list: {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
        counterReset: 'list-item',
    },
}));

const CamKetKhachHang = () => {
    const classes = useStyles();
    const camKet = [
        'Hỗ trợ giá tốt nhất',
        'Giao xe nhanh nhất',
        'Hỗ trợ mọi thủ tục',
        'Trả góp lãi suất cực thấp',
        'Tư vấn tận tình',
        'Hỗ trợ mọi dịch vụ',
    ];

    return (
        <Box className={classes.commitmentBox}>
            <Typography className={classes.title}>
                CAM KẾT VỚI KHÁCH HÀNG
            </Typography>
            <List className={classes.list}>
                {camKet.map((text, index) => (
                    <ListItem key={index} className={classes.listItem}>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default CamKetKhachHang;